// * GET =====================================
export const USER_GROUP_GET = (userGroupId: string) =>
  `/user_group/${userGroupId}`;

// * PATCH ===================================

// * POST ====================================
/** Update half of the former dual-use POST /user_group; creation is USER_GROUP_PUT_CREATE (SEN-5297). */
export const USER_GROUP_POST_UPDATE = `/user_group/update`;

// * DELETE ==================================
export const USER_GROUP_DELETE = (userGroupId: string) =>
  `/user_group/${userGroupId}`;

// * PUT =====================================

/** Create half of the former dual-use POST /user_group (SEN-5297). */
export const USER_GROUP_PUT_CREATE = `/user_group/create`;
